import { PcApiResponse } from '@/api/pc-api/types';
import { EdocProduct } from '@/api/pc-api/v1/product/list/types';
import { api } from '@/utils/api';

export const getProductListEdoc = (isTest?: boolean) => {
  return api<PcApiResponse<EdocProduct[]>>('get', `/pc-api/v1/product/list/edoc`, { isTest });
};
